module.exports = __webpack_public_path__ + "assets/img/martin_sheen-a92357a6.jpg";